import { withNamespaces } from 'react-i18next';
import {
    Col,
    Container,
    Row,
    Spinner,
} from 'reactstrap';

import Navigator from 'src/components/Navigator';
import BidsOverTime from './components/BidsOverTime';
import NeedsYourAttention from './components/NeedsYourAttention';
import QuickActions from './components/QuickActions';
import RecentFreights from './components/RecentFreights';
import StatusDonutChart from './components/StatusDonutChart';
import SummaryWidgets from './components/SummaryWidgets';
import useCarrierGuardDashboard from './hooks/useCarrierGuardDashboard';

const GuardCarriersDashboard = ({
    t,
}) => {
    const {
        data,
        isError,
        isFetching,
    } = useCarrierGuardDashboard({
        t,
    });

    if (isFetching) {
        return (
            <div className="page-content">
                <Container className="py-5 text-center" fluid>
                    <Spinner color="primary" />
                    <p className="mt-2">{t('Loading')}...</p>
                </Container>
            </div>
        );
    }

    if (isError || !data) {
        return (
            <div className="page-content">
                <Container fluid>
                    <div className="alert alert-danger" role="alert">
                        {t('Unable to load dashboard data. Please try again.')}
                    </div>
                </Container>
            </div>
        );
    }

    return (
        <div className="page-content carrier-guard-page carrier-guard-dashboard-page">
            <Container fluid>
                <Row className="mb-4">
                    <Col lg="12">
                        <Navigator
                            pageTitle={t('Dashboard')}
                            translate={false}
                        />

                        <p className="text-muted mb-0">
                            {t("Here's what's happening with your freights.")}
                        </p>
                    </Col>
                </Row>

                <SummaryWidgets widgets={data.summary} />

                <Row className="mb-4">
                    <Col className="mb-4 mb-xl-0" lg="6" xl="4">
                        <StatusDonutChart
                            segments={data.freightStatus.segments}
                            subtitle="Overview of your freights across all stages."
                            title="Freight Status"
                            total={data.freightStatus.total}
                            totalLabel="Total Freights"
                        />
                    </Col>

                    <Col className="mb-4 mb-xl-0" lg="6" xl="4">
                        <StatusDonutChart
                            segments={data.verificationResults.segments}
                            subtitle="Results from carrier verification on received bids."
                            title="Carrier Verification Results"
                            total={data.verificationResults.total}
                            totalLabel="Total Bids"
                        />
                    </Col>

                    <Col lg="12" xl="4">
                        <BidsOverTime bids={data.bidsOverTime} />
                    </Col>
                </Row>

                <Row>
                    <Col className="mb-4 mb-xl-0" xl="8">
                        <RecentFreights freights={data.recentFreights} />
                    </Col>

                    <Col xl="4">
                        <Row>
                            <Col className="mb-4" md="6" xl="12">
                                <NeedsYourAttention items={data.attentionItems} />
                            </Col>

                            <Col md="6" xl="12">
                                <QuickActions />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default withNamespaces()(
    GuardCarriersDashboard
);
